// extracted by mini-css-extract-plugin
export var cartContainer = "_hz-4";
export var gray = "_hz-1";
export var itemContainer = "_hz-2";
export var itemDetails = "_hz-3";
export var strong = "_hz-0";